export var CALLABLE_HOOKS;
(function (CALLABLE_HOOKS) {
    CALLABLE_HOOKS["isValidQuery"] = "__HOOK__IS__VALID__QUERY__";
})(CALLABLE_HOOKS || (CALLABLE_HOOKS = {}));
export var NON_CALLABLE_HOOKS;
(function (NON_CALLABLE_HOOKS) {
    NON_CALLABLE_HOOKS["query"] = "query";
})(NON_CALLABLE_HOOKS || (NON_CALLABLE_HOOKS = {}));
//# sourceMappingURL=index.js.map